module.exports = "<section id=\"overviewSection\" class=\"container-fluid resort-overview\" *ngIf=\"resort\">\n  <div class=\"row resort-overview__inner\">\n    <div class=\"col-12\">\n      <read-more [text]=\"resort.hasOverview ? resort.overview : resort.resortDescription\" [maxLength]=\"300\"></read-more>\n      <!-- {{ resort.hasOverview ? resort.overview : resort.resortDescription }} -->\n    </div>\n  </div>\n</section>"


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/resort-detail/resort-overview.component.html
// module id = ../../../../../src/app/resort-detail/resort-overview.component.html
// module chunks = main